import { useMutation } from '@tanstack/react-query';

import type { MutationHookOptions } from 'src/types/global';
import { useAPI } from 'src/util/use-api';

type RemoveGroupFromBinderParams = {
  binderId: string;
  groupId: string;
};

export const useRemoveGroupFromBinder = (
  options: MutationHookOptions<void, Error, RemoveGroupFromBinderParams>
) => {
  const { API } = useAPI();

  return useMutation({
    mutationFn: async ({ binderId, groupId }: RemoveGroupFromBinderParams) => {
      return (
        await API?.bindersAPI.bindersProfileUserGroupsDestroy({
          binderId,
          profileUserGroupId: groupId,
        })
      )?.data;
    },

    ...options,
  });
};
